// AppRoutes.jsx (The file you provided, with modifications)

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import ArticlePage from './pages/ArticlePage';
import AllArticles from './pages/AllArticles';
// import AllGallery from './pages/AllGallery'; // No longer needed directly here
import AllVideos from './pages/AllVideos';
import NotFound from './pages/NotFound';
import AllDemos from './pages/AllDemos';
import DemoPage from './pages/DemoPage';

// ⭐ IMPORT THE NEW WRAPPER COMPONENT
import FullGalleryWrapper from './widgets/FullGalleryWrapper';

const AppRoutes = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                
                {/* --- Primary Routes (Unchanged) --- */}
                <Route index element={<Home />} />
                <Route path="home" element={<Home />} />

                {/* --- Content Sections --- */}
                
                {/* 1. Article Routes (Unchanged) */}
                <Route path="articles">
                    <Route index element={<AllArticles />} /> 
                    <Route path="all" element={<AllArticles />} />
                    <Route path="/articles/featured" element={<AllArticles featuredOnly={true} />} /> 
                    <Route path=":slug" element={<ArticlePage />} /> 
                </Route>
                
                {/* 2. Videos Routes (Unchanged) */}
                <Route path="videos"> 
                    <Route index element={<AllVideos />} /> 
                    <Route path="all" element={<AllVideos />} />
                </Route>

                {/* 3. Gallery Routes: ⭐ USE GALLERYWRAPPER INSTEAD OF ALLGALLERY */}
                <Route path="gallery">
                    {/* /gallery (index) & /gallery/all are both GalleryWrapper */}
                    <Route index element={<FullGalleryWrapper />} />
                </Route>

                {/* 4. Demos Routes (Unchanged) */}
                <Route path="demos">
                    <Route index element={<AllDemos />} /> 
                    <Route path="all" element={<AllDemos />} /> 
                    <Route path=":demo" element={<DemoPage />} /> 
                </Route>
                
                {/* --- Navigation Routes (Unchanged) --- */}
                <Route path="about" element={<Home />} />
                <Route path="projects" element={<Home />} />
                <Route path="journey" element={<Home />} />
                <Route path="contact" element={<Home />} />

                {/* --- 404 Catch-all (Unchanged) --- */}
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
};

export default AppRoutes;